import { type IUser } from '@/types/IUser';

const useCurrentUser = (): IUser | null => {
  try {
    const userStr = localStorage.getItem('user');
    if (userStr === null) return null;
    return JSON.parse(userStr) as IUser;
  } catch {
    return null;
  }
};

export default useCurrentUser;
